import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { CheckCircle2, ArrowLeft } from "lucide-react";
import { api, apiErr } from "@/lib/api";
import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";
import DynamicForm from "@/components/site/DynamicForm";

export default function HireTalent() {
  const [content, setContent] = useState(null);
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);
  useEffect(() => { api.get("/content").then((r) => setContent(r.data)).catch(() => {}); }, []);
  const fc = content?.forms?.hire || {};
  const fields = content?.form_builder?.hire || [];

  const submit = async (values) => {
    setLoading(true);
    try {
      await api.post("/hire-talent", values);
      setDone(true);
      toast.success("Request submitted! Our team will reach out shortly.");
    } catch (err) { toast.error(apiErr(err.response?.data?.detail) || "Submission failed"); }
    finally { setLoading(false); }
  };

  return (
    <div>
      <Header />
      <section className="bg-navy text-white py-16">
        <div className="max-w-3xl mx-auto px-6">
          <Link to="/" className="inline-flex items-center gap-1.5 text-sm text-slate-300 hover:text-white mb-4"><ArrowLeft size={16} /> Back to Home</Link>
          <h1 className="font-display font-bold text-4xl tracking-tight">{fc.title || "Hire Talent"}</h1>
          <p className="mt-3 text-slate-300">{fc.subtitle || "Share your hiring requirement and receive a curated shortlist of pre-screened candidates."}</p>
        </div>
      </section>
      <section className="py-16">
        <div className="max-w-3xl mx-auto px-6">
          {done ? (
            <div data-testid="hire-success" className="bg-white rounded-2xl border border-slate-200 p-10 text-center">
              <CheckCircle2 className="mx-auto text-emerald-brand" size={56} />
              <h2 className="mt-4 font-display font-semibold text-2xl text-navy">{fc.success_title || "Thank you!"}</h2>
              <p className="mt-2 text-slate-600">{fc.success_message || "Your hiring request has been received. Our recruitment team will contact you shortly."}</p>
              <Link to="/" className="inline-block mt-6 bg-emerald-brand text-white font-semibold rounded-full px-6 py-3 hover:bg-emerald-dark transition-colors">Back to Home</Link>
            </div>
          ) : (
            content && <DynamicForm fields={fields} onSubmit={submit} loading={loading} submitLabel={fc.submit_label || "Submit Request"} testid="hire-talent-form" />
          )}
        </div>
      </section>
      <Footer content={content} />
    </div>
  );
}
